export default [{
  "type": "Notice",
  "name": "Notice",
  "settings": {},
  "children": []
}];